import { render, staticRenderFns } from "./MerchantsStores.vue?vue&type=template&id=69c05cae&"
import script from "./MerchantsStores.vue?vue&type=script&lang=js&"
export * from "./MerchantsStores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports